/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import {SHOW_MESSAGE,HIDE_MESSAGE} from '../_actions/message.actions';
import {MESSAGES,MESSAGE_TYPES} from '../constants/APP_CONSTANTS';

export const INITIAL_STATE = {
    show: false,
    message: '',
    type: MESSAGE_TYPES["default"],
    firstLoad: true
};

export function messageReducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        case SHOW_MESSAGE: {
            const message =MESSAGES[action.payload.messageKey] ? MESSAGES[action.payload.messageKey] : action.payload.messageKey;
            const messageType = MESSAGE_TYPES[action.payload.type] ? MESSAGE_TYPES[action.payload.type] : MESSAGE_TYPES["default"];
            return {...state, show:true, message: message, type: messageType, firstLoad:false};
        }
        case HIDE_MESSAGE: {
            return {...state, show:false};
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/message.reducer.js